<template>
  <div class="slider-container" @mousedown="startDrag" @touchstart="startDrag">
    <div class="slider-track"></div>
    <div class="slider-selected-track" :style="{ width: trackWidth }"></div>
    <img
        class="slider-thumb"
        :style="{ left: thumbLeft }"
        src="~assets/img/icn_slider_box_count.svg"
        @mousedown.stop="startDrag"
        @touchstart.stop="startDrag"
    />
  </div>
</template>

<script>
export default {
  name: 'MySlider',
  props: {
    value: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      currentValue: this.value,
      dragging: false,
      bufferPx: 30
    };
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue;
    }
  },
  computed: {
    trackWidth() {
      return `calc(((100% - ${this.bufferPx * 2}px) * (${this.currentValue - 1} / 100)) + ${this.bufferPx}px)`; // Adjust for 1 to 100 range
    },
    thumbLeft() {
      return `calc(((100% - ${this.bufferPx * 2}px) * (${this.currentValue - 1} / 100)) + ${this.bufferPx}px)`; // Adjust for 1 to 100 range
    }
  },
  methods: {
    startDrag() {
      event.preventDefault();

      this.dragging = true;
      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.stopDrag);
      document.addEventListener('touchmove', this.onDrag);
      document.addEventListener('touchend', this.stopDrag);
    },
    onDrag(event) {
      event.preventDefault();
      if (!this.dragging) return;
      const slider = this.$el;
      const rect = slider.getBoundingClientRect();

      // 양옆으로 10씩 여유공간.

      const allWidth = rect.width - (this.bufferPx * 2);
      const startPoint = rect.left + this.bufferPx;

      const clientX = event.touches ? event.touches[0].clientX : event.clientX;
      let newValue = ((clientX - startPoint) / allWidth) * 100;
      newValue = Math.round(Math.max(1, Math.min(100, newValue)));
      this.currentValue = newValue;
      this.$emit('input', newValue); // Ensure the prop is updated correctly
    },
    stopDrag() {
      this.dragging = false;
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);
      document.removeEventListener('touchmove', this.onDrag);
      document.removeEventListener('touchend', this.stopDrag);
    }
  }
}
</script>

<style scoped lang="scss">
.slider-container {
  position: relative;
  width: calc(100% + 30px);
  height: 5px;
  background-color: #EDEFF2;
  user-select: none;

  left: -15px;
  right: -15px;
}

.slider-track {
  position: absolute;
  width: 100%;
  height: 5px;
  background-color: #EDEFF2;
}

.slider-selected-track {
  position: absolute;
  height: 5px;
  background-color: $main-color;
}

.slider-thumb {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 41.41px;
  height: 30.01px;
  cursor: pointer;
}
</style>
